import React, { useState } from "react";
import Modal1 from "../DIsplay/Modal/Modal1";
import { enqueueSnackbar } from "notistack";
import cancelEsimBooking from "../../controllers/esim/cancelEsimBooking";

function CancelEsimBookingModal({ open, setOpen, booking, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const handleCancel = async () => {
    setLoading(true);
    const res = await cancelEsimBooking(booking?._id);
    setLoading(false);

    if (res?.return) {
      enqueueSnackbar(res?.msg || "eSIM booking cancelled successfully", {
        variant: "success",
      });
      setOpen(false);
      if (onSuccess) onSuccess();
      else window.location.reload();
    } else {
      enqueueSnackbar(res?.msg || "Failed to cancel eSIM booking", {
        variant: "error",
      });
    }
  };

  return (
    <Modal1 open={open} setOpen={setOpen}>
      <div className="p-6 flex flex-col items-center text-center lg:min-w-[500px]">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Cancel Booking?
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to cancel this eSIM order? This action cannot be
          undone.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 w-full">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="w-full sm:w-1/2 border border-gray-300 text-gray-700 rounded-md py-2.5 text-sm font-medium hover:bg-gray-50 transition"
          >
            No
          </button>
          <button
            type="button"
            onClick={handleCancel}
            disabled={loading}
            className="w-full sm:w-1/2 bg-red-600 text-white rounded-md py-2.5 text-sm font-medium hover:bg-red-700 transition flex items-center justify-center disabled:opacity-60"
          >
            {loading ? <div className="buttonLoader"></div> : "Yes, Cancel"}
          </button>
        </div>
      </div>
    </Modal1>
  );
}

export default CancelEsimBookingModal;
